import { Navigate } from "react-router-dom";
import NotFound from "../pages/public/NotFound";
import Landing from "../pages/public/Landing";
import { ROUTES } from "../constant/routes";
import PrivacyPolicy from "../pages/public/PrivacyPolicy";
import TermsOfService from "../pages/public/TermsOfService";
import GDPRPolicy from "../pages/public/GDPRPolicy";
import Compliance from "../pages/public/Compliance";
import Blogs from "../pages/public/Blogs";
import BlogDetail from "../pages/public/Blogs/BlogDetail";

const otherRouter = [
  {
    path: "/",
    element: <Landing />,
  },
  {
    path: ROUTES.BLOGS,
    element: <Blogs />,
  },
  {
    path: `${ROUTES.BLOGS}/:id`,
    element: <BlogDetail />,
  },
  {
    path: ROUTES.PRIVACY_POLICY,
    element: <PrivacyPolicy />,
  },
  {
    path: ROUTES.TERMS,
    element: <TermsOfService />,
  },
  {
    path: ROUTES.GDPR_POLICY,
    element: <GDPRPolicy />,
  },
  {
    path: ROUTES.COMPLIANCE,
    element: <Compliance />,
  },
  {
    path: ROUTES.NOT_FOUND,
    element: <NotFound />,
  },
  {
    path: "*",
    element: <Navigate to={ROUTES.NOT_FOUND} />,
  },
];

export default otherRouter;
